(() => {
  const pattern = /\biphone\b/gi;
  const ignored = 'script,style,noscript,textarea,input,code,pre,[contenteditable="true"],.mg-brand-name';
  function normalizeText(node) {
    const parent = node.parentElement;
    if (!parent || parent.closest(ignored) || !/\biphone\b/i.test(node.data)) return;
    if (parent.namespaceURI !== 'http://www.w3.org/1999/xhtml' || parent.closest('option,title')) {
      const value = node.data.replace(pattern, 'iPhone');
      if (node.data !== value) node.data = value;
      return;
    }
    const fragment = document.createDocumentFragment();
    let offset = 0;
    for (const match of node.data.matchAll(pattern)) {
      fragment.append(document.createTextNode(node.data.slice(offset, match.index)));
      const word = document.createElement('span');
      word.className = 'mg-brand-name';
      word.textContent = 'iPhone';
      fragment.append(word);
      offset = match.index + match[0].length;
    }
    fragment.append(document.createTextNode(node.data.slice(offset)));
    node.replaceWith(fragment);
  }
  function normalize(root) {
    if (root.nodeType === Node.TEXT_NODE) return normalizeText(root);
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(ignored)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(normalizeText);
    for (const element of [root, ...root.querySelectorAll('[alt],[title],[aria-label]')]) {
      if (element.closest(ignored)) continue;
      for (const name of ['alt', 'title', 'aria-label']) {
        const value = element.getAttribute(name);
        if (value && /\biphone\b/i.test(value)) element.setAttribute(name, value.replace(pattern, 'iPhone'));
      }
    }
  }
  normalize(document.body);
  document.title = document.title.replace(pattern, 'iPhone');
  const pending = new Set();
  let scheduled = false;
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') pending.add(record.target);
      else record.addedNodes.forEach(node => pending.add(node));
    }
    if (scheduled || !pending.size) return;
    scheduled = true;
    requestAnimationFrame(() => {
      const nodes = [...pending];
      pending.clear();
      scheduled = false;
      nodes.filter(node => node.isConnected).forEach(normalize);
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
